// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__fwtqb","title":"Images45_title__2bdxg","images":"Images45_images__3QQQg"};